import { $, $$, isTablet, sliderConfig } from '@utils';
import Swiper from 'swiper';
import { Navigation, Scrollbar, A11y, FreeMode } from 'swiper/modules';

function init() {
  if (!$('[data-au-news-header-slider]')) return;

  const slidersArray = [];

  addEventListeners(slidersArray);
  if (isTablet.matches) buildSlider(slidersArray);
}

function addEventListeners(slidersArray) {
  isTablet.addEventListener('change', () => toggleNewsHeaderSlidersCreation(slidersArray));
}

function buildSlider(slidersArray) {
  $$('[data-au-news-header-slider]').forEach((slider) => {
    const newsHeaderSlider = new Swiper(slider, {
      modules: [Navigation, Scrollbar, A11y, FreeMode],
      ...sliderConfig,
    });

    slidersArray.push(newsHeaderSlider);
  });
}

function toggleNewsHeaderSlidersCreation(slidersArray) {
  if (isTablet.matches) {
    buildSlider(slidersArray);
    return;
  }

  slidersArray.forEach((slider) => slider.destroy());
}

export default { init };
